<template>
    <div class="aside mb-3 d-flex gap-3">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: "TabMenu",
    };
</script>